import {
  CheckOutlined,
  CloseOutlined,
  EditOutlined,
} from "@ant-design/icons/lib/icons";
import {Descriptions, Input, Select, Spin, Button, notification, Space} from "antd";
import React, { useState, useContext } from "react";
import { OrderContext } from "../../Context/OrderContex";
import {sendShipment, updateOrderStatus, updatePaymentStatus} from "../../Service/order";
import { startInsurance } from "../../Service/console";
import { formatDate } from "../../utils/date"; 
import { notify } from "../../utils/notify";
import CargoModal from "../../Modals/CargoModal";

const { Option } = Select;
function OrderCard(OrderProps) {
  const { id, createdAt, total, orderNumber, orderStatus, paymentStatus, updateOrder, couponCode, totalCodeDiscount, totalDiscountWithoutCode, totalOrderCount,transaction } =
    OrderProps;
  const { OrderStatus, PaymentStatus } = useContext(OrderContext);
  const [updating, setUpdating] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cargoModalVisible, setCargoModalVisible] = useState(false);
  const _updateOrderStatus = (value) => {
    setUpdating(true);
    updateOrderStatus(id, value).then(() => {
      setUpdating(false);
      updateOrder();
    });
  };
  const _updatePaymentStatus = (value) => {
    setUpdating(true);
    updatePaymentStatus(id, value).then(() => {
      setUpdating(false);
      updateOrder();
    });
  };
  const list = [
    {
      source: "id",
      title: "Sipariş id",
      display: id,
    },
    {
      source: "createdAt",
      title: "Oluşturulma Tarihi",
      display: formatDate(createdAt,true,"DD.MM.YYYY HH:mm:ss",false),
    },
    {
      source: "total",
      title: "Toplam Tutar",
      display: total,
    },
    {
      source: "orderNumber",
      title: "Sipariş Numarası",
      display: orderNumber,
    },
    {
      source: "orderStatus",
      title: "Sipariş durumu",
      value: orderStatus,
      display: OrderStatus.data.find(
        (Orderstat) => Orderstat.id === orderStatus
      )?.value,
      submit: _updateOrderStatus,
      options: OrderStatus.data,
      editable: true,
    },
    {
      source: "totalOrderCount",
      title: "Toplam Sipariş Sayısı",
      display: totalOrderCount,
    },
    {
      source: "paymentStatus",
      title: "Ödeme durumu",
      value: paymentStatus,
      display: PaymentStatus.data.find(
        (Orderstat) => Orderstat.id === paymentStatus
      )?.value,
      submit: _updatePaymentStatus,
      options: PaymentStatus.data,
      editable: true,
    },
        {
      source: "couponCode",
      title: "İndirim",
      display: couponCode ? "Uygulandı" : "Uygulanmadı",
    },
      {
      source: "couponCode",
      title: "İndirim Kodu",
      display: couponCode ?? "-",
    },
    {
      source: "totalCodeDiscount",
      title: "İndirim Tutarı",
      display: totalCodeDiscount > 0 ? totalCodeDiscount : "-",
    },
    {
      source: "totalDiscountWithoutCode",
      title: "İndirimsiz Tutar",
      display: totalDiscountWithoutCode > 0 ? totalDiscountWithoutCode : "-",
    },
    {
      source: "installmentCount",
      title: "Taksit Sayısı",
      display: transaction?.installmentCount <= 1 ? "Tek Çekim" : transaction?.installmentCount + " Taksit",
    },
  ];

  const _startInsurance = (orderNumber) => {
    notify("info");
    startInsurance(orderNumber)
      .then(() => {
        notify("success");
      })
      .catch(() => {
        notify("error");
      });
  };

  const onFinish = (values) => {
    //console.log(values)
    notify("info");
    sendShipment(values)
        .then(() => {
          notify("success");
          setCargoModalVisible(false)
        })
        .catch(() => {
          notify("error");
          setCargoModalVisible(false)
        });
  };

  const onCancel = () => {
    setCargoModalVisible(false)
  };

  return (
    <Spin spinning={updating}>
      <Descriptions title="Sipariş Detay" bordered column={2} extra={<>
        <Space align="baseline">
          <Button type="orange" onClick={setCargoModalVisible}>Kargo İşlemleri</Button>
          <Button type="primary" onClick={() => _startInsurance(orderNumber)}>Sigorta Başlat</Button>
        </Space>
      </>}>
        {list.map((item) => (
          <Descriptions.Item key={item.source} label={item.title}>
            <EditableItem
              value={item.value}
              display={item.display}
              options={item.options}
              editable={item.editable}
              submit={item.submit}
            />
          </Descriptions.Item>
        ))}
      </Descriptions>
      <CargoModal visible={cargoModalVisible} onFinish={onFinish} onCancel={onCancel} loading={loading} data={OrderProps}/>
    </Spin>
  );
}

const EditableItem = ({ value, submit, display, options = [], editable }) => {
  const [edit, setedit] = useState(false);
  const [selected, setselected] = useState(value);
  return !edit ? (
    <>
      <p>{display}</p>
      {editable && (
        <EditOutlined
          onClick={() => {
            setedit(true);
          }}
        />
      )}
    </>
  ) : (
    <>
      <div>
        <Select
          defaultValue="lucy"
          style={{ width: 120 }}
          onChange={(val) => setselected(val)}
          value={selected}
        >
          {options.map((option) => (
            <Option value={option.id}>{option.value}</Option>
          ))}
        </Select>
      </div>
      <CheckOutlined onClick={() => submit(selected)} />
      <CloseOutlined onClick={() => setedit(false)} />
    </>
  );
};

export default OrderCard;
